module.exports = __webpack_public_path__ + "assets/images/CHF100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CHF100.png
// module id = 1337
// module chunks = 1